import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Home = _resolveComponent("Home");
  return _openBlock(), _createElementBlock("div", {
    class: "home",
    style: _normalizeStyle({
      background: 'url(' + $data.url + ') no-repeat',
      backgroundSize: '100% 100%'
    })
  }, [_createVNode(_component_Home, {
    msg: "Welcome to Your Vue.js App"
  })], 4);
}